import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAuthColaborador } from '../contexts/AuthColaboradorContext';

const Configuracoes = () => {
  const { user, changePassword: changePasswordUsuario } = useAuth();
  const { colaborador, changePassword: changePasswordColaborador } = useAuthColaborador();
  const isColaborador = !!colaborador && !user;

  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const dadosUsuario = user || colaborador;
  const changePassword = isColaborador ? changePasswordColaborador : changePasswordUsuario;

  const handleAlterarSenha = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha.length < 6) {
      setErro('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setErro('A confirmação da senha não confere.');
      return;
    }
    setEnviando(true);
    try {
      const res = isColaborador
        ? await changePassword(senhaAtual, novaSenha)
        : await changePassword({ senhaAtual, novaSenha, confirmarSenha });
      if (res?.success) {
        setSenhaAtual('');
        setNovaSenha('');
        setConfirmarSenha('');
      }
    } catch (_) {
      setErro('Não foi possível alterar a senha. Verifique a senha atual.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-neutral-900 mb-6">
        Configurações
      </h1>

      {/* Dados do usuário logado */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-neutral-100 mb-6">
        <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
          <h3 className="text-lg font-semibold text-neutral-700">Meus dados</h3>
        </div>
        <div className="p-6">
          {dadosUsuario ? (
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              <div>
                <dt className="font-medium text-neutral-500">Nome</dt>
                <dd className="mt-1 text-neutral-900">{dadosUsuario.nome}</dd>
              </div>
              <div>
                <dt className="font-medium text-neutral-500">E-mail (login)</dt>
                <dd className="mt-1 text-neutral-900">{dadosUsuario.email}</dd>
              </div>
              {user?.perfil && (
                <div>
                  <dt className="font-medium text-neutral-500">Perfil</dt>
                  <dd className="mt-1 text-neutral-900 capitalize">{user.perfil}</dd>
                </div>
              )}
            </dl>
          ) : (
            <p className="text-neutral-600">Carregando...</p>
          )}
        </div>
      </div>

      {/* Alterar senha */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-neutral-100">
        <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
          <h3 className="text-lg font-semibold text-neutral-700">Alterar senha</h3>
          <p className="text-sm text-neutral-500 mt-1">Use uma senha forte com pelo menos 6 caracteres.</p>
        </div>
        <div className="p-6">
          <form onSubmit={handleAlterarSenha} className="space-y-4 max-w-md">
            {erro && (
              <div className="p-3 rounded-md bg-red-50 text-red-700 text-sm">
                {erro}
              </div>
            )}
            <div>
              <label htmlFor="senhaAtual" className="block text-sm font-medium text-neutral-700 mb-1">
                Senha atual
              </label>
              <input
                id="senhaAtual"
                type="password"
                value={senhaAtual}
                onChange={(e) => setSenhaAtual(e.target.value)}
                required
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Digite sua senha atual"
              />
            </div>
            <div>
              <label htmlFor="novaSenha" className="block text-sm font-medium text-neutral-700 mb-1">
                Nova senha
              </label>
              <input
                id="novaSenha"
                type="password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                required
                minLength={6}
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Mínimo 6 caracteres"
              />
            </div>
            <div>
              <label htmlFor="confirmarSenha" className="block text-sm font-medium text-neutral-700 mb-1">
                Confirmar nova senha
              </label>
              <input
                id="confirmarSenha"
                type="password"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
                minLength={6}
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Repita a nova senha"
              />
            </div>
            <button
              type="submit"
              disabled={enviando}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {enviando ? 'Alterando...' : 'Alterar senha'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Configuracoes;
